<script>
import {computed, onMounted, ref} from "vue";
import useValidation from "@/use/Validation";
import {usePaySectionStore} from "@/stores/PaySection";
import useSharedData from "@/use/SharedData";
import useTools from "@/use/Tools";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";
import {storeToRefs} from "pinia";

export default {
    props: {
        addAction: Boolean,
        updateAction: Boolean,
        deleteAction: Boolean,
        viewAction: Boolean,
    },
    setup(props) {
        const {mxRules} = useValidation();
        const readonly = computed(() => props.deleteAction || props.viewAction);
        const {loading, overlay, dialog, inputColor, backgroundColor} = useSharedData();
        const {$route, $refs, $i18n} = useTools();
        const {getBack} = useSharedMethod();
        const paySectionStore = usePaySectionStore();


        const step = ref(1);
        const stepOneValidate = ref(true);
        const stepTwoValidate = ref(true);
        const stepThreeValidate = ref(true);
        const stepFourValidate = ref(true);
        const stepFiveValidate = ref(true);
        const allValidate = ref(true);

        /*const paySection = ref({
            editable: false,
            notWritable: false,
            formule: null,
            regularization: "0",
            cotisable: "0",
            brute: "0",
            conge: "0",
            stateChargePrintable: "0",
            totauxPrintable: "0",
            recapPrintable: "0",
            journalPrintable: "0",
            blockFormula: "0",
            fixeInitial: "0",
            isAbsenceRetenue: false,
            relations: [],
        });*/

        const {paySection} = storeToRefs(paySectionStore);

        const types = [
            {id: "1", name: $i18n.t('pay_section.type_1')},
            {id: "2", name: $i18n.t('pay_section.type_2')},
            {id: "3", name: $i18n.t('pay_section.type_3')},
            {id: "4", name: $i18n.t('pay_section.type_4')},
            {id: "5", name: $i18n.t('pay_section.type_5')},
            {id: "6", name: $i18n.t('pay_section.type_6')},
            {id: "7", name: $i18n.t('pay_section.type_7')},
            {id: "8", name: $i18n.t('pay_section.type_8')},
            {id: "9", name: $i18n.t('pay_section.type_9')},
        ];
        const impositions = [
            {id: "0", name: $i18n.t('pay_section.imposable_0')},
            {id: "1", name: $i18n.t('pay_section.imposable_1')},
            {id: "2", name: $i18n.t('pay_section.imposable_2')},
        ];

        const variables = [
            {id: "N_HR_ABS", name: $i18n.t('pay_section.variable_N_HR_ABS'),},
            {id: "N_JR_ABS", name: $i18n.t('pay_section.variable_N_JR_ABS')},
            {id: "N_HR_SUP", name: $i18n.t('pay_section.variable_N_HR_SUP')},
            {id: "N_HR_TRAV", name: $i18n.t('pay_section.variable_N_HR_TRAV')},
            {id: "N_JR_TRAV", name: $i18n.t('pay_section.variable_N_JR_TRAV')},
            {id: "N_JR_CONGE", name: $i18n.t('pay_section.variable_N_JR_CONGE')},
        ];

        const bulteinePrintableOptions = [
            {id: '1', name: $i18n.t('pay_section.bulteine_printable_1')},
            {id: '2', name: $i18n.t('pay_section.bulteine_printable_2')},
            {id: '3', name: $i18n.t('pay_section.bulteine_printable_3')},
            {id: '4', name: $i18n.t('pay_section.bulteine_printable_4')},
            {id: '5', name: $i18n.t('pay_section.bulteine_printable_5')},
        ];


        function findById(id) {
            loading.value = true;
            axios.get(`/paySections/${id}`).then((response) => {
                paySection.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function isValid() {
            stepOneValidate.value = $refs.form1.validate();
            stepTwoValidate.value = $refs.form2.validate();
            stepThreeValidate.value = $refs.form3.validate();
            stepFourValidate.value = $refs.form4.validate();
            stepFiveValidate.value = $refs.form5.validate();
            allValidate.value = stepOneValidate.value
                && stepTwoValidate.value
                && stepThreeValidate.value
                && stepFourValidate.value
                && stepFiveValidate.value;
            return stepOneValidate.value && stepTwoValidate.value && stepThreeValidate.value && stepFourValidate.value && stepFiveValidate.value;
        }

        function save() {
            if (isValid()) {
                loading.value = true;
                axios.post('/paySections', paySection.value).then((response) => {
                    paySectionStore.addPaySection(response.data);
                    revien();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        function update() {
            if (isValid()) {
                loading.value = true;
                axios.put('/paySections', paySection.value).then((response) => {
                    paySectionStore.updatePaySection(response.data);
                    revien();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        function remove() {
            loading.value = true;
            axios.delete(`/paySections/${paySection.value.id}`).then(() => {
                paySectionStore.deletePaySection(paySection.value);
                revien();
            }).finally(() => {
                loading.value = false;
            });
        }

        function revien() {
            paySectionStore.setPaySection({...paySectionStore.backupPaySection});
            getBack();
        }

        onMounted(() => {
            if (!props.addAction) {
                findById($route.params.id);
            }
        })

        return {
            mxRules,
            readonly,
            paySectionStore,
            step,
            stepOneValidate,
            stepTwoValidate,
            stepThreeValidate,
            stepFourValidate,
            stepFiveValidate,
            allValidate,
            loading,
            overlay,
            dialog,
            inputColor,
            backgroundColor,
            paySection,
            variables,
            impositions,
            types,
            bulteinePrintableOptions,
            save,
            update,
            remove,
            revien,
        }
    },
};
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        max-width="950"
        scrollable
    >
        <v-card flat>
            <w-dialog-toolbar
                :add-action="addAction"
                :update-action="updateAction"
                :delete-action="deleteAction"
                :view-action="viewAction"
            ></w-dialog-toolbar>
            <w-overlay
                :loading="loading"
                :overlay="overlay"
                :delete-action="deleteAction"
                @cancel="overlay = false"
                @remove="remove"
            ></w-overlay>
            <v-card-text>
                <v-tabs
                    class="tabs"
                    color="teal"
                    vertical
                    slider-size="7"
                    :background-color="backgroundColor"
                >
                    <v-tab>
                        <v-icon left v-if="stepOneValidate">mdi-information-variant</v-icon>
                        <v-icon left v-else color="red">mdi-alert</v-icon>
                        {{ $t("pay_section.generale") }}
                    </v-tab>
                    <v-tab>
                        <v-icon left v-if="stepTwoValidate">mdi-calculator</v-icon>
                        <v-icon left v-else color="red">mdi-alert</v-icon>
                        {{ $t("pay_section.calcule") }}
                    </v-tab>
                    <v-tab>
                        <v-icon left v-if="stepThreeValidate">mdi-monitor</v-icon>
                        <v-icon left v-else color="red">mdi-alert</v-icon>
                        {{ $t("pay_section.display") }}
                    </v-tab>
                    <v-tab>
                        <v-icon left v-if="stepFourValidate">mdi-printer-3d-nozzle</v-icon>
                        <v-icon left v-else color="red">mdi-alert</v-icon>
                        {{ $t("pay_section.print") }}
                    </v-tab>
                    <v-tab>
                        <v-icon left v-if="stepFiveValidate">mdi-link</v-icon>
                        <v-icon left v-else color="red">mdi-alert</v-icon>
                        {{ $t("pay_section.relative") }}
                    </v-tab>
                    <v-tab-item eager>
                        <v-container fluid>
                            <v-form ref="form1" lazy-validation>
                                <v-row dense>
                                    <w-fieldset title="Désignation">
                                        <v-row dense>
                                            <v-col cols="6">
                                                <strong>{{ $t('common.code') }} *</strong>
                                                <w-text-field
                                                    v-model="paySection.code"
                                                    :readonly="!addAction"
                                                    :hint="$t('pay_section.code_hint')"
                                                    :rules="[mxRules.required]"
                                                />
                                            </v-col>
                                            <v-col cols="6">
                                                <strong>{{ $t('common.order') }} *</strong>
                                                <w-text-field
                                                    v-model="paySection.ordre"
                                                    :readonly="readonly"
                                                    type="number"
                                                    :rules="[mxRules.required]"
                                                />
                                            </v-col>
                                            <v-col cols="6">
                                                <strong>{{ $t('common.label') }} *</strong>
                                                <w-text-field
                                                    v-model="paySection.label"
                                                    :readonly="readonly"
                                                    :rules="[mxRules.required]"
                                                />
                                            </v-col>
                                            <v-col cols="6">
                                                <w-label :label="'تعيين'" required/>
                                                <w-text-field
                                                    v-model="paySection.labelInArabic"
                                                    :readonly="readonly"
                                                    :rules="[mxRules.required]"
                                                />
                                            </v-col>
                                        </v-row>
                                    </w-fieldset>
                                    <br/>
                                    <w-fieldset :title="$t('pay_section.type')">
                                        <v-row dense>
                                            <v-col cols="12">
                                                <v-radio-group
                                                    v-model="paySection.type"
                                                    row
                                                    class="mt-n2"
                                                    hide-details="auto"
                                                    :rules="[mxRules.required]"
                                                >
                                                    <v-radio
                                                        v-for="(type, index) in types"
                                                        :key="index"
                                                        :value="type.id"
                                                        :label="type.name"
                                                        :readonly="readonly"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-col>
                                        </v-row>
                                    </w-fieldset>
                                    <br/>
                                    <w-fieldset title="Options">
                                        <v-row dense>
                                            <v-col cols="12">
                                                <v-radio-group
                                                    v-model="paySection.imposable"
                                                    row
                                                    class="mt-n2"
                                                    hide-details="auto"
                                                    :rules="[mxRules.required]"
                                                >
                                                    <v-radio
                                                        v-for="(imposition, index) in impositions"
                                                        :key="index"
                                                        :value="imposition.id"
                                                        :label="imposition.name"
                                                        color="red"
                                                        :readonly="readonly"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-checkbox
                                                    v-model="paySection.cotisable"
                                                    :label="`${$t('pay_section.in_cotisable')}`"
                                                    true-value="1"
                                                    false-value="0"
                                                    hide-details
                                                    color="orange"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                            <v-col cols="6">
                                                <v-checkbox
                                                    v-model="paySection.brute"
                                                    :label="`${$t('pay_section.in_brute')}`"
                                                    true-value="1"
                                                    false-value="0"
                                                    hide-details
                                                    color="cyan"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                            <v-col cols="6">
                                                <v-checkbox
                                                    v-model="paySection.regularization"
                                                    :label="`${$t('pay_section.in_regul')}`"
                                                    true-value="1"
                                                    false-value="0"
                                                    hide-details
                                                    color="purple"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                            <v-col cols="6">
                                                <v-checkbox
                                                    v-model="paySection.conge"
                                                    :label="`${$t('pay_section.in_holiday')}`"
                                                    true-value="1"
                                                    false-value="0"
                                                    hide-details
                                                    color="teal"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                        </v-row>
                                    </w-fieldset>
                                    <br/>
                                    <w-fieldset :title="$t('common.other')">
                                        <v-row dense>
                                            <v-col cols="6">
                                                <v-checkbox
                                                    v-model="paySection.editable"
                                                    :label="$t('pay_section.editable_label')"
                                                    inset
                                                    color="orange"
                                                    hide-details
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                            <v-col cols="6">
                                                <v-checkbox
                                                    v-model="paySection.isAbsenceRetenue"
                                                    color="red"
                                                    :label="$t('pay_section.is_absence_retenue')"
                                                    inset
                                                    hide-details
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                            <v-col cols="12">
                                                <w-label :label="$t('pay_section.type_time')"/>
                                                <w-enum-select
                                                    v-model="paySection.variable"
                                                    :items="variables"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                        </v-row>
                                    </w-fieldset>
                                </v-row>
                            </v-form>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item eager>
                        <v-container fluid>
                            <v-form ref="form2" lazy-validation>
                                <v-row>
                                    <v-col cols="12">
                                        <calculator v-model="paySection.formule"/>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-checkbox
                                            v-model="paySection.blockFormula"
                                            true-value="1"
                                            false-value="0"
                                            :label="`${$t('pay_section.ignore_formule')}`"
                                            hide-details
                                            color="cyan"
                                        />
                                    </v-col>
                                    <v-col cols="12">
                                        <strong>{{ $t('pay_section.precision') }}</strong>
                                        <w-enum-select
                                            v-model="paySection.decimalNumber"
                                            :items="[0, 1, 2, 3, 4, 5]"
                                            :readonly="readonly"
                                        />
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item eager>
                        <v-container fluid>
                            <v-form ref="form3" lazy-validation>
                                <v-row dense>
                                    <v-col cols="12">
                                        <strong>{{ $t('pay_section.display_format') }}</strong>
                                        <w-text-field v-model="paySection.viewFormat" :readonly="readonly"/>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-radio-group row v-model="paySection.fixeInitial">
                                            <v-radio :label="`${$t('pay_section.fixe')}`" value="1"/>
                                            <v-radio :label="`${$t('pay_section.exceptionel')}`" value="2"/>
                                            <v-radio :label="`${$t('pay_section.variable')}`" value="3"/>
                                        </v-radio-group>
                                    </v-col>
                                    <v-col cols="12">
                                        <strong>{{ $t('pay_section.init_val') }}</strong>
                                        <w-text-field v-model="paySection.initValue" :readonly="readonly"/>
                                    </v-col>
                                    <v-col cols="12">
                                        <strong>{{ $t('pay_section.min_val') }}</strong>
                                        <w-text-field v-model="paySection.minValue" :readonly="readonly"/>
                                    </v-col>
                                    <v-col cols="12">
                                        <strong>{{ $t('pay_section.max_val') }}</strong>
                                        <w-text-field v-model="paySection.maxValue" :readonly="readonly"/>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-checkbox
                                            v-model="paySection.notWritable"
                                            true-value="1"
                                            false-value="0"
                                            inset
                                            :label="`${$t('pay_section.block_write_pay')}`"
                                            color="red"
                                        />
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item eager>
                        <v-container fluid>
                            <v-form ref="form4" lazy-validation>
                                <w-fieldset :title="$t('pay_section.printing_on_bultein')">
                                    <v-row dense>
                                        <v-col cols="12">
                                            <strong>{{ $t('pay_section.column_print') }} *</strong>
                                            <w-enum-select
                                                v-model="paySection.bulteinePrintable"
                                                :items="bulteinePrintableOptions"
                                                :readonly="readonly"
                                                :rules="[mxRules.required]"
                                            />
                                        </v-col>
                                        <v-col cols="6">
                                            <strong>{{ $t('pay_section.base_num') }}</strong>
                                            <text-field-pay-section v-model="paySection.basePrint" :readonly="readonly"/>
                                        </v-col>
                                        <v-col cols="6">
                                            <strong>{{ $t('pay_section.taux') }}</strong>
                                            <text-field-pay-section v-model="paySection.tauxPrint" :readonly="readonly"/>
                                        </v-col>
                                        <!--<v-col cols="12">
                                            <v-checkbox
                                                :label="`${$t('pay_section.print_if_zero')}`"
                                                color="purple"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>-->
                                    </v-row>
                                </w-fieldset>
                                <br/>
                                <w-fieldset :title="$t('pay_section.print_on_recap')">
                                    <v-row dense>
                                        <v-col cols="12">
                                            <v-checkbox
                                                v-model="paySection.recapPrintable"
                                                true-value="1"
                                                false-value="0"
                                                :label="`${$t('pay_section.recap_print')}`"
                                                color="cyan"
                                                hide-details
                                            />
                                        </v-col>
                                        <v-col cols="12">
                                            <strong>{{ $t('pay_section.recap_base') }}</strong>
                                            <text-field-pay-section v-model="paySection.recapBase" :readonly="readonly"/>
                                        </v-col>
                                    </v-row>
                                </w-fieldset>
                                <br/>
                                <w-fieldset title="Journal">
                                    <v-row dense>
                                        <v-col cols="12">
                                            <v-checkbox
                                                v-model="paySection.journalPrintable"
                                                true-value="1"
                                                false-value="0"
                                                :label="`${$t('pay_section.journal_print')}`"
                                                color="cyan"
                                                hide-details
                                            />
                                        </v-col>
                                        <v-col cols="12">
                                            <v-checkbox
                                                v-model="paySection.stateChargePrintable"
                                                true-value="1"
                                                false-value="0"
                                                :label="`${$t('pay_section.charge_print')}`"
                                                color="blue"
                                                hide-details
                                            />
                                        </v-col>
                                        <v-col cols="12">
                                            <v-checkbox
                                                v-model="paySection.totauxPrintable"
                                                true-value="1"
                                                false-value="0"
                                                :label="`${$t('pay_section.totaux_print')}`"
                                                color="blue"
                                                hide-details
                                            />
                                        </v-col>
                                        <v-col cols="12">
                                            <strong>{{ $t('pay_section.taux_text') }}</strong>
                                            <w-text-field v-model="paySection.tauxText" :readonly="readonly"/>
                                        </v-col>
                                    </v-row>
                                </w-fieldset>
                                <br/>
                                <w-fieldset :title="$t('pay_section.transfer_to_pccompta')">
                                    <v-row dense>
                                        <v-col cols="12">
                                            <strong>{{ $t('pay_section.transfer_compta') }}</strong>
                                            <w-text-field v-model="paySection.comptaCompte" :readonly="readonly"/>
                                        </v-col>
                                        <v-col cols="6">
                                            <strong>{{ $t('pay_section.debit_account') }}</strong>
                                            <w-text-field v-model="paySection.debitAccount" :readonly="readonly"/>
                                        </v-col>
                                        <v-col cols="6">
                                            <strong>{{ $t('pay_section.credit_account') }}</strong>
                                            <w-text-field v-model="paySection.creditAccount" :readonly="readonly"/>
                                        </v-col>
                                    </v-row>
                                </w-fieldset>
                                <br/>
                            </v-form>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item eager>
                        <v-container fluid>
                            <w-fieldset
                                :title="$t('pay_section.relative')"
                                show-add-action
                                @add="paySection.relations.push({})"
                            >
                                <v-form ref="form5" lazy-validation>
                                    <v-row
                                        dense
                                        v-for="(relation, index) in paySection.relations"
                                        :key="index"
                                    >
                                        <v-col cols="7">
                                            <strong>{{ $t('module.pay_section') }}</strong>
                                            <text-field-pay-section
                                                v-model="relation.code"
                                                :readonly="readonly"
                                                :rules="[mxRules.required]"
                                            />
                                        </v-col>
                                        <v-col cols="3">
                                            <strong>Position *</strong>
                                            <w-enum-select
                                                v-model="relation.position"
                                                :readonly="readonly"
                                                :items="[
                                                        {id: 'FIX', name: $t('common.FIX')},
                                                        {id: 'VARIABLE', name: $t('common.VARIABLE')},
                                                        {id: 'RESULT', name: $t('common.RESULT')},
                                                    ]"
                                                :rules="[mxRules.required]"
                                            />
                                        </v-col>
                                        <v-col cols="2">
                                            <v-btn
                                                icon
                                                color="red"
                                                cla
                                                class="mt-6"
                                                @click="paySection.relations.splice(index, 1)"
                                            >
                                                <v-icon color="red">mdi-trash-can</v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-checkbox
                                                v-model="relation.manualAdd"
                                                :label="$t('pay_section.manual_add')"
                                                color="blue"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-checkbox
                                                v-model="relation.autoAdd"
                                                :label="$t('pay_section.auto_add')"
                                                color="teal"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-checkbox
                                                v-model="relation.manualDelete"
                                                :label="$t('pay_section.manual_delete')"
                                                color="red"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-checkbox
                                                v-model="relation.autoDelete"
                                                :label="$t('pay_section.auto_delete')"
                                                color="pink"
                                            ></v-checkbox>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </w-fieldset>
                        </v-container>
                    </v-tab-item>
                </v-tabs>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="revien"/>
                <w-btn-add
                    :show="addAction"
                    :loading="loading"
                    :error="!allValidate"
                    @press="save"
                />
                <w-btn-update
                    :show="updateAction"
                    :loading="loading"
                    :error="!allValidate"
                    @press="update"
                />
                <w-btn-delete
                    :show="deleteAction"
                    :loading="loading"
                    @press="overlay = true"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style lang="scss" scoped>
div.tabs [role="tab"] {
    justify-content: flex-start;
}
</style>